const API_BASE_URL = process.env.REACT_APP_API_URL;

if (!API_BASE_URL) {
    console.warn('REACT_APP_API_URL is not set. API calls may fail in production.');
}

export const getApiUrl = (path) => {
    // Always use the full URL in production
    if (process.env.NODE_ENV === 'production') {
        if (!API_BASE_URL) {
            console.error('REACT_APP_API_URL is required in production');
            return `https://byopdf-backend.onrender.com${path}`;
        }
        return `${API_BASE_URL}${path}`;
    }
    
    // In development, use relative path (proxy will handle it)
    return path;
};

export default {
    getApiUrl
};